<style lang="scss" scoped>
.icon {
  border-radius: 50%;
  width: 4px;
  height: 4px;
}
</style>
<template>
  <div>
    <tj-title-bar :title="healthcheckBookTeam.teamName+'每日预约情况'"></tj-title-bar>
    <div class="bg_fff radius3 mt15">
      <section class="flex pl15 pr15 pt10 pb10 aic">
        <p class="fs14 flex1">
          <el-button size="mini" @click="$router.back()">返回</el-button>
          分配号源：<span class="color_main">{{ total.bookedNumberSourceTotal || total.waitCheckCount }}</span>个
          剩余号源：<span
            class="color_red">{{
            total.numberSourceTotal - total.bookedNumberSourceTotal || total.surplusNumberSourceTotal
          }}</span>个
        </p>
        <p class="flex0">
          <el-button size="mini" icon="el-icon-arrow-left" @click="handler('-')"></el-button>
          <el-button size="mini" icon="el-icon-arrow-right" @click="handler('+')"></el-button>
          <span class="fs14 ml10">{{ currText }}</span>
        </p>
      </section>
      <el-table :data="list" size="mini" border style="width: 100%">
        <el-table-column label="单位" prop="healthcheckTeamName"></el-table-column>
        <el-table-column label="时段">
          <template slot-scope="{row}">
            <span>{{ row.appointmentTimeInterval }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预约状态">
          <template slot-scope="{row}">
            <div class="flex aic">
              <span class="icon mr5" :class="[getIconColor(row.orderStatus)]"></span>
              <span>{{ row.orderStatus|filter_get_order_status }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="预约人（病案号）">
          <template slot-scope="{row}">
            <span>{{ row.healthcheckerName }}({{ row.healthcheckMedicalRecord }})</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <dialog-tj-yuyue ref="yuyue" @ok="getData"></dialog-tj-yuyue>
  </div>
</template>
<script>
import TjTitleBar from "../components/tj-title-bar";
import dayjs from 'dayjs';
import {healthcheckService} from "../services/healthcheck";
import {riliItemCacheKey} from "../config";
import {filter_get_order_status} from "../filter";
import DialogTjYuyue from "../components/dialog-tj-yuyue";
import {timeFormat} from "../../../common/lib/utils";

export default {
  name: 'tj-list',
  filters: {filter_get_order_status},
  components: {DialogTjYuyue, TjTitleBar},
  data() {
    return {
      curr: new Date(),
      total: {},
      list: [],
      range: []
    }
  },
  computed: {
    currText() {
      return dayjs(this.curr).format('YYYY月MM年DD日');
    }
  },
  created() {
    const {date} = this.$route.query;
    if (date) this.curr = dayjs(date);
    this.total = this.$cache.get(riliItemCacheKey);
    this.getData();
  },
  methods: {
    async getData() {
      const teamId = this.healthcheckBookTeam.id;
      const date = dayjs(this.curr).format('YYYY-MM-DD');
      this.list = await healthcheckService.tjhyDate(date, teamId);
      const range = await healthcheckService.tjOrderDateList(teamId);
      this.range = range.map(r => {
        return {...r, date: r.healthcheckCountDate.replace(/\//g, '-')};
      });
    },
    getIconColor(status) {
      if (['OVERDUE', 'NO_PAY_CANCEL', 'CANCEL'].includes(status)) return 'bg_red';
      if (['WAIT_PAY', 'WAIT_HANDLE'].includes(status)) return 'bg_green';
      return 'bg_main';
    },
    sub(data) {
      const {curr} = this;
      this.$refs.yuyue.open({
        ...data,
        week: timeFormat(dayjs(curr).valueOf(), '%W'),
        date: dayjs(curr).format('YYYY-MM-DD')
      })
    },
    handler(type) {
      const {curr} = this;
      const index = this.range.findIndex(r => r.date === dayjs(curr).format('YYYY-MM-DD'));
      if (type === '+') {
        if (index + 1 === this.range.length) return this.$message.error('没有了');
        else {
          this.total = this.range[index + 1];
          this.curr = this.total.date;
        }
      } else if (type === '-') {
        if (index === 0) return this.$message.error('没有了');
        else {
          this.total = this.range[index - 1];
          this.curr = this.total.date;
        }
      } else this.curr = new Date();
      this.getData();
    }
  },
}
</script>
